import { render, staticRenderFns } from "./Line-Item-New.vue?vue&type=template&id=08d808f4"
import script from "./Line-Item-New.vue?vue&type=script&lang=js"
export * from "./Line-Item-New.vue?vue&type=script&lang=js"
import style0 from "./Line-Item-New.vue?vue&type=style&index=0&id=08d808f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports